import {RegisterType} from '../component-registry';
import {GuidedUiNoLinksSection, GuidedUiQuickLinkSection} from '../../models/Guided.schema';
import {GuidedQuickLinkDetails} from '../../models/quick-link';
import {onlyMatchingSource} from '../../utils';
import type { GuidedV2FactoryState } from '../../models/ui';
import {h} from '@stencil/core';
import {NoLinksMessage} from './no-links-message';



export class GuidedV2NoLinksMessageFactory {
  @RegisterType(GuidedUiNoLinksSection.type)
  render<T extends GuidedQuickLinkDetails>(inputData: GuidedUiNoLinksSection, state: GuidedV2FactoryState<T>){
      const {
        itemSources,
        message,
        messageName,
        clickTarget,
      } = inputData; //comes from configuration

      const {
        results,
        searchTerm,
        // highlightedIndex,
        labelProvider,
        eventEmitters,
      } = state;

      const foundResults = results.filter(onlyMatchingSource(itemSources));

      if(foundResults.length > 0)
        return <div data-message="results found, not showing message"></div>;

      return <NoLinksMessage
        message={labelProvider(`guided-v2.no-links-message.${messageName}`,message)}
        searchTerm={searchTerm}
        clickTarget={clickTarget}
        eventEmitters={eventEmitters}
        ctaMessage={labelProvider('guided-v2-no-links-message.cta-message','View All Results')}
      ></NoLinksMessage>;
  };
}
